import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { PropertySearch } from '__generated__/api/types';

import { UitkIcon } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';
import { UitkText } from 'uitk-react-text';

const LinkTracked = ClickTracker('a');

export interface HeaderMessageLinkProps extends PropertySearch.ResultsSummary {
  linkName?: string;
}

export const HeaderMessageLink: React.FunctionComponent<HeaderMessageLinkProps> = ({ icon, link, linkName, value }) => (
  <UitkMoreInfoTrigger type={200}>
    <LinkTracked href={link.url} linkName={linkName || value} rfrr={link.referrerId} target="_blank">
      <UitkText weight="bold">{value}</UitkText>
      {icon && <UitkIcon name={icon.id} />}
    </LinkTracked>
  </UitkMoreInfoTrigger>
);
HeaderMessageLink.displayName = 'HeaderMessageLink';
